import http from './http'
import { mockApiBaseUrl, apiBaseUrl } from './url-config'

const baseUrl = apiBaseUrl || mockApiBaseUrl

export default {
    // 获取微信SDK配置
    getWxSdkInfo: (params = {}) => http('GET', `${baseUrl}/farmer/jssdk_info`, params),
    // 用户登录
    login: (params = {}) => http('post', `${baseUrl}/farmer/login_mobile`, params),
    // 用户注册协议
    getAgreementInfo: (params = {}) => http('post', `${baseUrl}/cmn/agreement/v1/info`, params),
    // 微信登录
    // loginWx: (params = {}) => http('post', `${baseUrl}/member/member/v1/login_wx`, params),
    loginWx: (params = {}) => http('post', `${baseUrl}/farmer/login_wx`, params),
    // 获取用户详情
    // getUserInfo: (params = {}) => http('post', `${baseUrl}/member/member/v1/info`, params),
    getUserInfo: (params = {}) => http('get', `${baseUrl}/farmer/user`, params),
    // 更新用户信息
    updateUserInfo: (params = {}) => http('PUT', `${baseUrl}/farmer/users`, params),
    // 获取首页闪图
    getFlashList: (params = {}) => http('GET', `${baseUrl}/content/flashes`, params),
    // 明码校验(产品防伪)
    publicVerify: (params = {}) => http('GET', `${baseUrl}/code/product/publicCode/verify`, params),
    // 暗码校验(深度防伪)
    matchVerify: (params = {}) => http('GET', `${baseUrl}/code/product/matchCode/verify`, params),
    // 校验明码(抽奖和追踪溯源)
    publicVerifyForGeneral: (params = {}) => http('GET', `${baseUrl}/code/publicCode/verify`, params),
    // 校验暗码(抽奖)
    matchVerifyForGeneral: (params = {}) => http('GET', `${baseUrl}/code/matchCode/verify`, params),
    // 校验暗码(追踪溯源)
    matchTrace: (params = {}) => http('GET', `${baseUrl}/code/product/matchCode/trace`, params),
    // 查看合格证
    getProductCertificate: (params = {}) => http('get', `${baseUrl}/code/productCertificate/${params.id}`, {}),
    // 发送短信验证码
    sendSms: (params = {}) => http('post', `${baseUrl}/farmer/smscode`, params),
    // 文章栏目
    getCategory: (params = {}) => http('get', `${baseUrl}/content/categories`, params),
    // 栏目banner
    getCategoryBanner: (params = {}) => http('GET', `${baseUrl}/content/articleBanners`, params),
    // 文章列表
    getArticleList: (params = {}) => http('GET', `${baseUrl}/content/articles`, params),
    // 文章详情 params = {} GET */:id
    getArticleDetail: (params = {}) => http('get', `${baseUrl}/content/articles/${params.id || null}`, {}),
    // 收藏文章
    collectArticle: (params = {}) => http('post', `${baseUrl}/content/collect/articles/${params.id || null}`, {}),
    // 轮播图 1-首页，2-活动，3-反馈意见
    getBanner: (params = {}) => http('get', `${baseUrl}/content/banners`, params),
    // 幸运抽奖
    luckydraw: (params = {}) => http('post', `${baseUrl}/activities/luckydraw/${params.activity_id || null}`, params),
    // 中奖列表
    getMemberPrizeList: (params = {}) => http('get', `${baseUrl}/activities/member/prizes`, params),
    // 联系我们
    getContactInfo: (params = {}) => http('get', `${baseUrl}/common/contacts`, params),
    // 提交意见反馈
    submitFeedback: (params = {}) => http('post', `${baseUrl}/common/feedbacks`, params),
    // 提交意见列表
    getFeedbacklist: (params = {}) => http('get', `${baseUrl}/common/feedbacks`, params),
    // 常见问题
    getFaqList: (params = {}) => http('get', `${baseUrl}/common/faqs`, params),
    // 积分来源
    getPointSourceList: (params = {}) => http('get', `${baseUrl}/farmer/pointSources`, params),
    // 积分明细
    getPointDetailList: (params = {}) => http('get', `${baseUrl}/farmer/pointDetails`, params),
    // 获取活动
    getActivity: (params = {}) => http('get', `${baseUrl}/activities/index`, params),
    // 中奖纪录
    getPrizeList: (params = {}) => http('get', `${baseUrl}/activities/prizes`, params),
    // 中奖纪录详情
    getPrizeDetail: (params = {}) => http('get', `${baseUrl}/activities/member/prizes/${params.id}`, {}),
    // 门店列表
    getShopList: (params = {}) => http('get', `${baseUrl}/basic/shops`, params),
    // 门店详情
    getShopDetail: (params = {}) => http('get', `${baseUrl}/basic/shops/${params.id}`, {}),
    // 保存自定义属性（抽奖填写信息、完善资料）
    saveCustom: (params = {}) => http('post', `${baseUrl}/custom/custom_field_values`, params),
    // 查询完善资料属性列表
    getMemberCustom: (params = {}) => http('GET', `${baseUrl}/custom/farmer/custom_field_values`, params),
    // 查询抽奖填写信息列表
    getActivityCustom: (params = {}) => http('GET', `${baseUrl}/custom/activity/custom_field_values/${params.id || null}`, {}),
    // 添加中奖收货地址 /activities/member/prizes/2
    addAddrs: (params = {}) => http('put', `${baseUrl}/activities/member/prizes/${params.prize_record_id}`, params),
    // 添加收货地址
    addRecivieAddrs: (params = {}) => http('put', `${baseUrl}/farmer/address`, params),
    // 获取区域列表
    getAreaList: (params = {}) => http('get', `${baseUrl}/farmer/areas`, params),
    // 获取农户经纬度信息列表
    getFarmerList: (params = {}) => http('get', `${baseUrl}/farmer/users/locations`, params),
    // 获取农户详情
    getFarmerDetail: (params = {}) => http('get', `${baseUrl}/farmer/users/location/${params.id}`, {}),
    // 获取农户产品购买记录
    getFarmerPurchHis: (params = {}) => http('get', `${baseUrl}/farmer/users/purchaseHistory/${params.id}`, {}),
    // 获取位置信息-首次更新农户定位信息
    getFarmerLocation: (params = {}) => http('put', `${baseUrl}/farmer/users/location`, params)
}
